import React, { useState } from 'react';
import {
  stackCreate,
  stackAddCard,
  roundAddStack,
  stackEditGold,
  stackEditSilver,
  roundRemoveStack,
  stackDelete,
  setCurrentRound,
  roundCreate
} from '../../redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import {
  getUserStacksForRound,
  getPlayerStacksFullValue,
  IsGameComplete
} from '../../redux/selectors';
import { makeStyles } from '@material-ui/core/styles';
import { Paper } from '../../components/paper';
import { Button } from '@material-ui/core';
import { StackSelector } from '../../components/stackSelector';
import { Redirect } from 'react-router-dom';
import { WildCard } from '../../components/wildCard';
import { CurrencyDisplay } from '../../components/currencyDisplay';

const useStyles = makeStyles(function(theme) {
  return {
    wildCardContainer: {
      display: 'flex'
    },
    roundDetailsContainer: {
      paddingTop: 28
    },
    roundManagementContainer: {
      width: 'calc(100% - 18px)',
      /* display: flex; */
      top: 56,
      background: 'white',
      position: 'fixed',
      left: 0,
      zIndex: 999,
      padding: '12px 9px'
    }
  };
});

export default () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const gameList = useSelector(state => state.games);
  const currentGame = gameList.currentGame;
  if (!currentGame) {
    return <Redirect to="/" />;
  }
  const roundList = useSelector(state => state.rounds);
  const playerList = useSelector(state => state.players);
  const gameComplete = useSelector(state => IsGameComplete(state));
  const currentRound = roundList.byId[roundList.currentRoundId];
  const [completeStatus, setCompleteStatus] = useState(false);

  const addStack = userId => {
    const stackId = 'stack' + Date.now();
    dispatch(stackCreate(stackId, userId));
    //add to round
    dispatch(roundAddStack(currentRound.roundId, stackId));
  };

  /**
   * goToNextRound
   */
  const goToNextRound = () => {
    if (gameComplete) {
      setCompleteStatus(true);
    } else {
      const roundId = 'round' + Date.now();
      const roundIndex = currentRound.index + 1; //first round always from this page
      let preexistingRoundId = null;

      //make sure that round doesn't exist
      for (const roundId in roundList.byId) {
        if (roundList.byId.hasOwnProperty(roundId)) {
          const round = roundList.byId[roundId];

          if (round.index === currentRound.index + 1) {
            preexistingRoundId = round.roundId;
          }
        }
      }

      if (preexistingRoundId) {
        dispatch(setCurrentRound(preexistingRoundId));
      } else {
        //create round
        dispatch(roundCreate(roundId, roundIndex));
        dispatch(setCurrentRound(roundId));
      }
    }
  };

  /**
   * gotoPreviousRound
   */
  const goToPreviousRound = () => {
    for (const roundId in roundList.byId) {
      if (roundList.byId.hasOwnProperty(roundId)) {
        const round = roundList.byId[roundId];

        if (round.index === currentRound.index - 1) {
          dispatch(setCurrentRound(round.roundId));
        }
      }
    }
  };

  //todo only get players in this game
  const getUserList = () => {
    let playerElements = [];

    gameList.byId[currentGame].players.map(playerId => {
      const user = playerList.byId[playerId];

      playerElements.push(
        <UserList user={user} currentRound={currentRound} addStack={addStack} />
      );
    });

    return playerElements;
  };

  if (completeStatus) {
    return <Redirect to="/complete" />;
  } else {
    return (
      <div
        className={classes.roundDetailsContainer}
        style={{ 'padding top': '12px' }}
      >
        <div className={classes.roundManagementContainer}>
          <Button
            disabled={currentRound.index === 0}
            onClick={goToPreviousRound}
          >
            Previous Round
          </Button>
          <Button onClick={goToNextRound} style={{ float: 'right' }}>
            Next Round
          </Button>
        </div>
        <span className={'title center'}>Round {currentRound.index + 1}</span>
        <div>{getUserList()}</div>
      </div>
    );
  }
};

const UserList = props => {
  const classes = useStyles();
  const { user, addStack, currentRound } = props;
  const dispatch = useDispatch();

  const userStacksValue = useSelector(state => getPlayerStacksFullValue(state));

  const getUserStacks = playerId => {
    return useSelector(state => getUserStacksForRound(state, playerId));
  };

  const handleAddStack = () => {
    addStack(user.id);
  };

  const editStack = (stackId, cardId, count) => {
    dispatch(stackAddCard(stackId, cardId, count));
  };

  const handleEditGold = (stackId, count) => {
    dispatch(stackEditGold(stackId, count));
  };

  const handleEditSilver = (stackId, count) => {
    dispatch(stackEditSilver(stackId, count));
  };

  const handleRemoveStack = stackId => {
    dispatch(roundRemoveStack(currentRound.roundId, stackId));
    dispatch(stackDelete(stackId));
  };

  const getStackElements = userStacks => {
    //for each user stack
    const stackElements = [];
    for (const stackId in userStacks) {
      if (userStacks.hasOwnProperty(stackId)) {
        stackElements.push(
          <Paper key={stackId}>
            {/* <span className='header-secondary'>Card Stack - {userStacks[stackId].value}</span> */}
            <React.Fragment>
              <StackSelector
                onStackChange={editStack}
                onStackRemove={handleRemoveStack}
                stackId={stackId}
                stacks={userStacks[stackId]}
              />
              <div className={classes.wildCardContainer}>
                <WildCard
                  id={stackId}
                  label={'Gold'}
                  count={userStacks[stackId].goldCount}
                  onClick={handleEditGold}
                />
                <WildCard
                  id={stackId}
                  label={'Silver'}
                  count={userStacks[stackId].silverCount}
                  onClick={handleEditSilver}
                />
              </div>
            </React.Fragment>
          </Paper>
        );
      }
    }

    return stackElements;
  };

  const total = (
    <span>
      Total: <CurrencyDisplay value={userStacksValue[user.id]} />
    </span>
  );

  return (
    <Paper key={user.name} title={`Player Name: ${user.name}`} subtitle={total}>
      {getStackElements(getUserStacks(user.id))}
      <Button style={{'margin-top': 12}} color="outlineButton" variant="outlined" onClick={handleAddStack}>
        + ADD STACK
      </Button>
    </Paper>
  );
};
